import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';

import {QrCodeReaderComponent} from './q-r-code-reader.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import {ValidationMessageModule} from '../../../../formbird-sc-shared/src/lib/components/validation/validation-message.module';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  declarations: [
    QrCodeReaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentSetupModule,
    ValidationMessageModule
  ],
  providers: []
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class QrCodeReaderModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(QrCodeReaderComponent, 'sc-q-r-code-reader', this.injector, pjson.version);
  }
}
